<template>
    <div>
        <div>
            <div class="d-flex flex-row mt-3 align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                    <form-input class="me-2" style="min-width: 320px" v-model="filters.query" placeholder="Search for a Card Deck"
                                @keypress.enter="search">
                        <template slot="prepend">
                            <inline-svg src="/assets/img/icons/search-icon.svg"></inline-svg>
                        </template>
                    </form-input>
                    <span>View</span>
                    <form-select class="ms-1 me-2"
                                 style="margin-right: 20px"
                                 v-model="filters.category"
                                 @change="search"
                                 :options="categoryFilterOptions"
                    />
                </div>
                <btn-group-toggle :options="[
                    {'label': 'Sort by date', 'value': 'by_date'},
                    {'label': 'Shared in community', 'value': 'shared_in_community'},
                    {'label': 'Partners', 'value': 'partner_decks'},
                    ]" v-model="filters.filter_by" @input="search">
                </btn-group-toggle>
            </div>
            <div v-if="cardDecks.length" class="deck-card-list" :class="{'loading' : loading.data}">
                <template v-for="cardDeck in cardDecks">
                    <deck-card-partner v-if="cardDeck.corporateBrand"
                                       :cardDeck="cardDeck"
                                       @onAssignCardDeck="assignCardDeck(cardDeck)"
                                       @onShareCollaboration="handleShareCollaboration(cardDeck)"
                                       @onEditCardDeck="handleEditCardDeck(cardDeck)"
                                       @onViewCards="handleViewCards">>
                    </deck-card-partner>
                    <deck-card-regular v-else
                                       :cardDeck="cardDeck"
                                       @onAssignCardDeck="assignCardDeck(cardDeck)"
                                       @onShareCollaboration="handleShareCollaboration(cardDeck)"
                                       @onEditCardDeck="handleEditCardDeck(cardDeck)"
                                       @onViewCards="handleViewCards">
                    </deck-card-regular>
                </template>
            </div>
            <div v-else-if="!loading.data">
                <no-card-decks>
                    <btn class="btn-outline-primary" @click="$router.push({ name: 'community.library'})">
                        Go to Community Library
                    </btn>
                    <btn class="btn-primary" @click="$modal.show('addCardModal')">
                        <inline-svg class="me-1" src="/assets/img/icons/file-plus-01.svg"></inline-svg>
                        Create a New Card Deck
                    </btn>
                </no-card-decks>
            </div>
            <div v-if="showLoadMore && !loading.data" class="flex-1 text-center">
                <btn class="btn-outline-light" @click="loadMore">
                    Load more
                    <inline-svg class="ms-1" src="/assets/img/icons/arrow-down.svg"></inline-svg>
                </btn>
            </div>
            <card-deck-assign :cardDeck="selectedCardDeck" :heroes="cardDeckHeroes"></card-deck-assign>
            <card-deck-share-collaboration :cardDeck="selectedCardDeck"></card-deck-share-collaboration>
            <card-deck-cards-modal :cardDeck="selectedCardDeck" @onAssignCardDeck="assignCardDeck(selectedCardDeck)"></card-deck-cards-modal>
        </div>
    </div>
</template>

<script>

import DeckCardPartner from "@/components/DeckCardPartner.vue";
import DeckCardRegular from "@/components/DeckCardRegular.vue";
import BtnGroupToggle from "@/components/core/BtnGroupToggle.vue";
import {modelListMixin} from "/src/mixins/modelListMixin.js";
import CardDeckAssign from "@/views/CardDecks/CardDeckAssign.vue";
import CardDeckCardsModal from "@/views/CardDecks/CardDeckCardsModal.vue";
import NoCardDecks from "@/components/NoCardDecks.vue";
import CardDeckShareCollaboration from "@/views/CardDecks/CardDeckShareCollaboration.vue";

export default {
    name: "CardDecksList",
    components: {CardDeckShareCollaboration, NoCardDecks, DeckCardRegular, DeckCardPartner, BtnGroupToggle, CardDeckAssign, CardDeckCardsModal},
    mixins: [modelListMixin],
    props: ['categoryFilterOptions'],
    data() {
        return {
            filters: {
                category: '',
                filter_by: 'by_date',
            },
            loading: {
                assign: false,
            },
            cardDecks: [],
            selectedCardDeck: null,
            cardDeckHeroes: [],
            cardDeckCollaborations: [],
            showLoadMore: true,
        }
    },
    watch: {
        'filters.query': function(newVal, oldVal) {
            if (oldVal !== '' && newVal === '') {
                this.getData();
            }
        }
    },
    mounted() {
        this.getData();
        this.$events.$on('loadMyCardDecks', () => {
            this.getData();
        });
    },
    methods: {
        getData() {
            this.loading.data = true;
            this.$http.post("/deck/my-decks", this.filters)
                .then((res) => {
                    this.showLoadMore = res.body.data.current_page !== res.body.data.last_page;
                    this.cardDecks = this.filters.page === 1 ? res.body.data.data : this.cardDecks.concat(res.body.data.data);
                    this.loading.data = false;
                })
                .catch((error) => {
                    this.loading.data = false;
                });
        },
        assignCardDeck(cardDeck) {
            this.selectedCardDeck = cardDeck;
            this.loading.assign = true;
            this.$http.post('/hero/my-heroes', {deck_id: this.selectedCardDeck.id})
                .then(function (res) {
                    this.loading.assign = false;
                    this.cardDeckHeroes = res.body.data;
                    this.$modal.hide('viewCardsModal')
                    this.$modal.show('assignCardDeckModal')
                }).catch(() => {
                this.loading.assign = false;
            });

        },
        handleShareCollaboration(cardDeck) {
            this.selectedCardDeck = cardDeck;
            this.$modal.show('shareCollaborationModal')
        },
        handleEditCardDeck(cardDeck) {
            this.$emit('onEditCardDeckItem', cardDeck);
        },
        handleViewCards(cardDeck) {
            this.selectedCardDeck = cardDeck;
            this.$modal.show('viewCardsModal')
        },
        loadMore() {
            this.filters.page++;
            this.getData();
        },
    }
}
</script>
